module.exports = __webpack_public_path__ + "media/images/faqs/bg-1024-53bdffb187e1d6294931b16a93935c4c.png";